// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"b95ec0fc","453":"9bf0fb47","909":"7adf753b"}[chunkId] + ".chunk.js";
};